"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputKeyConditional = void 0;
const KHInputKeyDerived_1 = require("./KHInputKeyDerived");
class KHInputKeyConditional extends KHInputKeyDerived_1.KHInputKeyDerived {
    constructor(inputSet, source, conditional, invert = false) {
        super(inputSet);
        this._source = source;
        this._conditional = conditional;
        this._invert = invert;
        // Clear out just down if not applicable.
        this.setInitalState();
    }
    setInitalState() {
        this.down = this._source.isDown() && this.getConditional();
        this.justDown = this._source.isJustDown() && this.getConditional();
    }
    getConditional() {
        const bool = this._conditional.get();
        return this._invert ? !bool : bool;
    }
    updateDerivedInput() {
        super.update(this._source.isDown() && this.getConditional());
    }
}
exports.KHInputKeyConditional = KHInputKeyConditional;
